/**
 * Status of the certification as provided by the regulatory authority.
 * tag: 3022
 * @readonly
 * @enum {number} (int)
 */
export enum AlgoCertificateStatus {
  Draft = 0,
  Approved = 1,
  Submitted = 2,
}
